<div fxLayout="column" fxLayoutWrap="wrap" style="min-width: 700px;">
  <div style="margin: 20px 0 0 0;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <span>Acta solicitada</span>
  </div>
  <div style="margin: 10px 0 0 0;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">

    <div fxFlex.gt-sm="90" fxFlex.gt-xs="90" fxFlex="90">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let record of sectionalItemRequestList; let i = index"
          style="border-left: 4px solid rgb(239, 130, 0);">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Acta N° {{i+1}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="start start">
            <ng-container *ngIf="record.stampTicket && record.stampTicket.id">

              <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
                Número de transacción: {{record.stampTicket.transactionNumber}}
              </div>   
              <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
                  Número de control: {{record.stampTicket.controlNumber}}
              </div>
            </ng-container>
          </div>
          <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="start start">

            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
              Tipo de acta: {{record.sectionalItem.name}}
            </div>
          </div>
          <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="start start">
             <ng-container *ngFor="let item of record.sectionalItemRequestPersons ">

              <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
              Apellido y nombre:  {{item.lastName}},{{item.firstName}} 
              </div>
              <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
                DNI: {{item.docNumber}}
              </div>
              

            </ng-container> 
            <!-- <ng-container *ngIf="record.sectionalItemRequestPersons.length > 0 ">

              <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
                Apellido y nombre:  {{record.sectionalItemRequestPersons[0].lastName}},{{record.sectionalItemRequestPersons[0].firstName}} 
              </div>
              <div fxFlex.gt-sm="40" fxFlex.gt-xs="40" fxFlex="40">
                DNI: {{record.sectionalItemRequestPersons[0].docNumber}}
              </div>

            </ng-container> -->
           
          </div>
          <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="start start">
            <div fxFlex.gt-sm="25" fxFlex.gt-xs="25" fxFlex="25">
              Tomo: {{record.sectionalItemRequestPersons[0].tome}}
            </div>
            <div fxFlex.gt-sm="25" fxFlex.gt-xs="25" fxFlex="25">
              Folio: {{record.sectionalItemRequestPersons[0].folio}}
            </div>
            <div fxFlex.gt-sm="25" fxFlex.gt-xs="25" fxFlex="25">
              Acta: {{record.sectionalItemRequestPersons[0].certificate}}
            </div>
            <div fxFlex.gt-sm="25" fxFlex.gt-xs="25" fxFlex="25">
              Año: {{record.sectionalItemRequestPersons[0].year}}
            </div>
            
          </div>
          <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="start start">
            <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
              Lugar de inscripción: {{record.sectionalItemRequestPersons[0].inscriptionPlaceName}}
            </div>
            <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
              Fecha de referencia: {{record.sectionalItemRequestPersons[0].date | date:'dd/MM/yyyy'}}
            </div>
          </div>

        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div style="margin: 20px 0 0 0; text-align: right;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <button (click)="closeDialog()" mat-button color="primary">Cerrar</button>
  </div>
</div>